import { useContent } from "contexts/contentContext/contentContext";
import { useEffect, useState } from "react";

interface useTranslationI {
  currentPage: string;
}
export const useTranslation = ({ currentPage }: useTranslationI) => {
  const [isTranslationLoaded, setIsTranslationLoaded] = useState();
  const { fetchConsts } = useContent();

  useEffect(() => {
    fetchConsts(setIsTranslationLoaded);
  }, [currentPage]);

  return { isTranslationLoaded };
};
